import { render } from "./App.vue?vue&type=template&id=665b2126"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=665b2126&lang=css"

import exportComponent from "/Users/mohammed/Desktop/Projects/Hala Al-Jazera/Agent Orders App/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__